// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YL-z","isFullWidth":"ZL-z","landingPageVideo":"_L-z","play":"aM-z","iframeVideo":"bM-z","playHidden":"cM-z","fullwidth":"dM-z"};